import { render } from "./ResetEmailSubmitted.vue?vue&type=template&id=6e6f0998&scoped=true"
import script from "./ResetEmailSubmitted.vue?vue&type=script&lang=js"
export * from "./ResetEmailSubmitted.vue?vue&type=script&lang=js"

import "./ResetEmailSubmitted.vue?vue&type=style&index=0&id=6e6f0998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6f0998"]])

export default __exports__